<template>
  <Layout>
    <div id="not_found__image_area">
      <img src="@img/404.png" />
    </div>

    <div id="not_found__description_area">
      <p>指定されたページが見つかりませんでした。</p>
    </div>

    <div id="not_found__description_detail_area">
      <p>申し訳ございません。お客様がアクセスしようとしたページ（URL）が見つかりませんでした。</p>
      <p>アドレスが正しく入力されているかご確認ください。</p>
      <p>指定されたページは削除されたか、移動した可能性があります。</p>
    </div>

    <div id="not_found__guidance_area">
      <p>再度アドレスを入力してもページが正しく表示されない場合は、以下のページからお探しください。</p>
    </div>

    <div id="not_found__link_area">
      <div class="not_found__link"><JafLink :href="hrefJafnaviTop" label="JAFナビトップ" /></div>
      <div class="not_found__link"><JafLink :href="hrefYutaiTop" label="会員優待" /></div>
      <div class="not_found__link"><JafLink :href="hrefDrive" label="ドライブ" /></div>
      <div class="not_found__link"><JafLink :href="hrefPresent" label="プレゼント" /></div>
      <div class="not_found__link"><JafLink :href="hrefJaf" label="JAF（日本自動車連盟）" /></div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main.vue'
import JafLink from '@components/not-found/link.vue'
import {
  JAF_NAVI_DRIVE,
  JAF_NAVI_DRIVE_ST,
  JAF_NAVI_PRESENT,
  JAF_NAVI_PRESENT_TEST,
  JAF_NAVI_TOP,
  JAF_NAVI_TOP_TEST,
  JAF_NAVI_YUTAI_TOP,
  JAF_NAVI_YUTAI_TOP_TEST,
  JAF_TOP,
  JAF_TOP_TEST,
} from '@/src/utils/link'

export default {
  metaInfo: {
    title: '404',
    meta: [{ name: 'description', content: '404' }],
  },
  components: { Layout, JafLink },
  computed: {
    isProduction() {
      return process.env.NODE_ENV === 'production'
    },
    hrefJafnaviTop() {
      return this.isProduction ? JAF_NAVI_TOP : JAF_NAVI_TOP_TEST
    },
    hrefYutaiTop() {
      return this.isProduction ? JAF_NAVI_YUTAI_TOP : JAF_NAVI_YUTAI_TOP_TEST
    },
    hrefDrive() {
      return this.isProduction ? JAF_NAVI_DRIVE : JAF_NAVI_DRIVE_ST
    },
    hrefPresent() {
      return this.isProduction ? JAF_NAVI_PRESENT : JAF_NAVI_PRESENT_TEST
    },
    hrefJaf() {
      return this.isProduction ? JAF_TOP : JAF_TOP_TEST
    },
  }
}
</script>

<style lang="scss" scoped>
#not_found__image_area {
  text-align: center;
  padding: 20px;

  img {
    max-width: 200px;
    width: 50vw;
    height: auto;
  }
}

#not_found__description_area {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;

  p {
    border-top: 2px solid #E74281;
    border-bottom: 2px solid #E74281;
    text-align: center;
    padding: 6px;
    font-size: 18px;
    color: #001a70;
    font-weight: bold;
  }
}

#not_found__description_detail_area {
  padding: 10px;
  p {
    text-align: center;
  }
}

#not_found__guidance_area {
  padding: 40px 10px 20px 10px;

  p {
    text-align: center;
  }
}

#not_found__link_area {
  padding: 15px;
}

@media screen and (min-width: 768px) {
  #not_found__description_area {
    p {
      width: 50%;
    }
  }

  #not_found__link_area {
    display: flex;
    justify-content: space-around;
    margin: 0 auto;
    max-width: 800px;
  }
}
</style>
